<template>
  <div class="login-box">
    <div class="fullScreen" @click="fullscreen">
      <i :class="isFullscreen? 'iconfont icon-tuichuquanping':'iconfont icon-ln_quanping'"></i>
    </div>
    <div class="login-form">
      <div class="top-text">01</div>
      <div class="login-header">
        <div class="text-title">新兴火龙果管理平台</div>
        <div class="english">设置新密码</div>
      </div>
      <el-form>
        <el-form-item>
          <div class="lable">手机号码:</div>
          <div class="input-icon">
            <img class="img-icon" :src="phoneUrl" alt />
            <input type="text" class="input" v-model="from.phoneName" v-on:input="phoneEvent" />
            <img class="state-img" src="../../assets/login/true.png" alt />
          </div>
        </el-form-item>
        <el-form-item>
          <div class="lable">短信验证码:</div>
          <div class="input-icon">
            <div class="code-box">
              <img class="img-icon" :src="noteUrl" alt />
              <input type="password" class="input-note" v-model="from.note" v-on:input="noteEvent" />
              <img class="state-img-note" src="../../assets/login/true.png" alt />
            </div>
            <div class="text-note">
              <span class="line"></span>
              <span class="send" @click="validateBtn">{{btnTitle}}</span>
            </div>
          </div>
        </el-form-item>
        <el-form-item>
          <div class="lable">图形验证码:</div>
          <div class="code">
            <div class="code-box">
              <img class="img-icon" :src="codeUrl" alt />
              <input type="text" class="input-code" v-model="from.code" v-on:input="codeEvent" />
              <img class="state-img" src="../../assets/login/true.png" alt />
            </div>
            <div class="text-code">
              <img src alt />
            </div>
          </div>
        </el-form-item>
      </el-form>
      <div class="login-btn">
        <div class="btn" @click="nextsTep">下一步</div>
      </div>
    </div>
  </div>
</template>
<script>
import phone from "../../assets/login/phone.png";
import phoneFocus from "../../assets/login/phoneFocus.png";
import note from "../../assets/login/note.png";
import noteFocus from "../../assets/login/noteFocus.png";
import codeFocus from "../../assets/login/codeFocus.png";
import code from "../../assets/login/code.png";
import screenfull from "screenfull";
export default {
  data() {
    return {
      phoneUrl: phone,
      noteUrl: note,
      codeUrl: code,
      from: {
        phoneName: "",
        note: "",
        code: ""
      },
      isFullscreen: false,
      disabled: false,
      btnTitle: '获取验证码'
    };
  },
  created() {
    let that = this;
    window.onresize = function() {
      if (screenfull.isFullscreen) {
        that.isFullscreen = true;
      } else {
        that.isFullscreen = false;
      }
    };
  },
  methods: {
    fullscreen() {
      screenfull.toggle();
      this.isFullscreen = true;
    },
    phoneEvent() {
      if (this.from.phoneName.length != 0) {
        this.phoneUrl = phoneFocus;
      } else {
        this.phoneUrl = phone;
      }
    },
    noteEvent() {
      if (this.from.note.length != 0) {
        this.noteUrl = noteFocus;
      } else {
        this.noteUrl = note;
      }
    },
    codeEvent() {
      if (this.from.code.length != 0) {
        this.codeUrl = codeFocus;
      } else {
        this.codeUrl = code;
      }
    },
    nextsTep() {
      this.$router.push({
        path: "/setpass"
      });
    },
    validateBtn() {
      //倒计时
      let time = 60;
      let timer = setInterval(() => {
        if (time == 0) {
          clearInterval(timer);
          this.disabled = false;
          this.btnTitle = "获取验证码";
        } else {
          this.btnTitle = time + "秒后重试";
          this.disabled = true;
          time--;
        }
      }, 1000);
    }
  }
};
</script>
<style lang="scss" scoped>
.login-box {
  width: 100%;
  height: 100%;
  background: url("../../assets/login/bg.png") no-repeat;
  background-size: 100% 100%;
  position: relative;
  .fullScreen {
    position: absolute;
    right: 40px;
    top: 20px;
    i {
      font-size: 30px;
      color: #9ad2b6;
    }
  }
  .login-form {
    width: 700px;
    padding: 80px 88px 0 90px;
    box-sizing: border-box;
    position: absolute;
    top: 70px;
    left: 1120px;
    .top-text {
      font-size: 50px;
      font-family: PangMenZhengDao;
      font-weight: 400;
      color: rgba(16, 196, 106, 0.2);
      position: absolute;
      top: 10px;
      left: 20px;
    }
    .login-header {
      padding-top: 10px;
      .english {
        font-size: 30px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #141414;
        line-height: 51px;
      }
      .text-title {
        font-size: 40px;
        font-family: HuXiaoBo-NanShen;
        font-weight: 700;
        color: rgba(16, 196, 106, 1);
        line-height: 51px;
      }
    }
    .el-form {
      margin-top: 44px;
      .lable {
        font-size: 20px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #131313;
        line-height: 50px;
        padding-left: 10px;
      }

      .input-icon {
        height: 40px;
        width: 100%;
        border-bottom: 1px solid rgba(153, 153, 153, 1);
        position: relative;

        .input {
          width: 91%;
          outline: none;
          border: 0px;
          background: transparent;
          line-height: 40px;
          font-size: 18px;
          padding-left: 15px;
          box-sizing: border-box;
        }
        .state-img {
          position: absolute;
          right: 0px;
          top: 10px;
        }
        .input-note {
          outline: none;
          border: 0px;
          width: 55%;
          padding-left: 15px;
        }
        .state-img-note {
          position: absolute;
          right: 30%;
          top: 10px;
        }
        .text-note {
          width: 130px;
          height: 40px;
          position: absolute;
          right: 0;
          top: -2px;
          cursor: pointer;
          text-align: center;
          display: flex;
          align-items: center;
          .line {
            display: inline-block;
            width: 1px;
            height: 30px;
            background: #e6e6e6;
            margin-right: 8px;
          }
          .send {
            font-size: 20px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #10c46a;
            line-height: 51px;
          }
        }
      }
      .img-icon {
        padding-left: 10px;
      }
      .code {
        height: 40px;
        width: 100%;
        display: flex;
        justify-content: space-between;
        .code-box {
          width: 70%;
          display: flex;
          align-items: center;
          border-bottom: 1px solid rgba(153, 153, 153, 1);
        }

        .input-code {
          width: 100%;
          outline: none;
          border: 0px;
          background: transparent;
          line-height: 40px;
          font-size: 18px;
          padding-left: 15px;
          box-sizing: border-box;
        }
        .text-code {
          width: 142px;
          height: 40px;
          background: #cf9c9c;
          letter-spacing: 15px;
          font-size: 20px;
          text-align: center;
        }
      }
      .el-form-item {
        margin-bottom: 30px;
      }
    }
  }
  .login-btn {
    margin-top: 40px;
    .btn {
      cursor: pointer;
      width: 520px;
      height: 50px;
      background-color: #10c469;
      text-align: center;
      font-size: 20px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #ffffff;
      line-height: 50px;
      box-shadow: 9px 6px 16px #d4f4e4;
    }
  }
}
</style>